<template>
    <div>
        <VersaoRelatorioDialog :dialog="dialogVersaoRelatorio" :relm_id="model.relm_id"
            @versaoRelatorioDialogClose="versaoRelatorioDialogClose" />

        <v-dialog v-model="isDialog" :max-width="800">
            <v-card>
                <v-card-title class="bg-header grey lighten-4">
                    <span class="text-h6 font-weight-bold grey--text text--darken-3">
                        <v-icon left color="primary">mdi-file-document-edit-outline</v-icon>
                        Modelo de Relatório
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogCloseModelosRelatorioDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="pt-4 px-4 pb-3">

                    <v-row dense>
                        <v-col cols="12">
                            <v-text-field outlined dense v-model="model.relm_descricao" label="Nome do Modelo"
                                hide-details type="text" @input="model.relm_descricao = ($event || '').toUpperCase()" />
                        </v-col>

                        <v-col cols="12" class="d-flex align-start">
                            <v-file-input v-model="pdfFile" label="Upload do Arquivo PDF" accept=".pdf" outlined dense
                                prepend-icon="" prepend-inner-icon="mdi-cloud-upload-outline"
                                :hint="model.relm_url_pdf ? 'Existe um arquivo salvo no servidor.' : 'Nenhum arquivo anexado ainda.'"
                                persistent-hint style="max-width: 300px;" class="mr-3" />

                            <v-btn :disabled="!model.relm_url_pdf || pdfFile" color="success" class="text-none mt-1"
                                :href="model.relm_url_pdf" target="_blank">
                                <v-icon left>mdi-eye</v-icon>
                                Visualizar
                            </v-btn>
                        </v-col>

                        <v-col cols="12" class="d-flex justify-end pt-2">
                            <v-btn color="success" class="text-none" @click="saveClick">
                                <v-icon left>mdi-content-save-check</v-icon>
                                Salvar
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-divider class="my-3"></v-divider>

                    <v-row dense v-if="isNovo == false">
                        <v-col cols="12" class="d-flex justify-end">
                            <v-btn color="primary" class="text-none" @click="novoVersaoClick">
                                Nova Versão
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12">
                            <v-data-table :headers="headers" :items="relversoes" class="elevation-1" :loading="loading"
                                dense no-data-text="Nenhum modelo encontrado">

                                <template v-slot:[`item.actions`]="{ item }">
                                    <v-btn class="text-none" size="small" text color="error" icon
                                        @click="excluiRelversoesClick(item)">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </template>

                                <template v-slot:[`item.relv_url`]="{ item }">
                                    <v-btn text :href="item.relv_url" icon color="primary">
                                        <v-icon>mdi-download</v-icon>
                                    </v-btn>
                                </template>

                                <template v-slot:[`item.relpadrao`]="{ item }">
                                    <v-icon :color="item.relpadrao ? 'success' : 'grey lighten-1'" small>
                                        {{ item.relpadrao ? 'mdi-check-circle' : 'mdi-minus-circle-outline' }}
                                    </v-icon>
                                </template>

                                <template v-slot:[`item.created_at`]="{ item }">
                                    <span>
                                        {{ item.created_at ? new Date(item.created_at).toLocaleString('pt-BR') : '-' }}
                                    </span>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { RelmodelosService } from '../../services/reports/relmodelosService.js';
import { RelversoesService } from '../../services/reports/relversoesService.js';
import VersaoRelatorioDialog from './VersaoRelatorioDialog.vue'

const relmodelosService = new RelmodelosService();
const relversoesService = new RelversoesService();

export default {
    props: {
        rela_id: String,
        relm_id: String,
        dialog: Boolean,
    },
    components: {
        VersaoRelatorioDialog
    },
    data: () => ({
        loading: false,
        isNovo: false,
        pdfFile: null,
        dialogVersaoRelatorio: false,
        model: {
            relm_id: '',
            rela_id: '',
            relm_descricao: '',
            relm_url_pdf: '',
        },
        headers: [
            { text: '>= v(SIC)', value: 'relv_vsic', align: 'start' },
            { text: 'Padrão', value: 'relpadrao', align: 'start' },
            { text: 'Criado Em:', value: 'created_at', align: 'start' },
            { text: 'URL', value: 'relv_url', align: 'start' },
            { text: 'Ação', value: 'actions', align: 'center' },
        ],
        relversoes: [],
    }),
    methods: {
        versaoRelatorioDialogClose() {
            this.dialogVersaoRelatorio = false;
            this.carregarRelversoes();
        },
        async novoVersaoClick() {
            this.dialogVersaoRelatorio = true;
        },
        async excluiRelversoesClick(redetalhe) {
            const confirmou = await this.$root.$confirm(
                'Exclusão',
                'Deseja realmente excluir?',
            );
            if (!confirmou) return;

            await relversoesService.remove(redetalhe.relv_id);
            this.carregarRelversoes();

            this.$store.dispatch('showSuccess', 'Excluído com sucesso!')
        },
        async saveClick() {
            if (this.validaSalvar() == false) return;

            try {
                this.$isLoading(true);

                this.model.rela_id = this.rela_id;
                // eslint-disable-next-line no-console
                //console.log(this.model);

                let form = new FormData()
                form.append('relm_descricao', this.model.relm_descricao)
                form.append('rela_id', this.rela_id)

                if (this.pdfFile)
                    form.append('pdf', this.pdfFile)

                if (this.model.relm_id) {
                    form.append('relm_id', this.model.relm_id)
                    this.model = await relmodelosService.update(this.model.relm_id, form);
                }
                else {
                    this.model = await relmodelosService.create(form);
                }

                this.pdfFile = null;
                this.isNovo = false;
                this.carregarRelversoes();

                this.$store.dispatch('showSuccess', 'Salvo com sucesso!')
                // this.dialogClose();
            } catch (error) {
                this.$store.dispatch('showError', error)
            } finally {
                this.$isLoading(false);
            }
        },
        validaSalvar() {
            if (!this.model.relm_descricao) {
                this.$store.dispatch('showError', "Informe o Nome do Modelo")
                return false;
            }
            return true
        },
        dialogCloseModelosRelatorioDialog() {
            this.$emit('dialogCloseModelosRelatorioDialog')
        },
        async carregarRelversoes() {
            this.loading = true;
            try {
                this.relversoes = await relversoesService.getAll(this.model.relm_id);
            } catch (error) {
                this.$store.dispatch('showError', error)
            } finally {
                this.loading = false;
            }
        }
    },
    computed: {
        isDialog: {
            get() {
                return this.dialog
            },
            set() {
                this.dialogCloseModelosRelatorioDialog();
            }
        }
    },
    watch: {
        async dialog() {
            this.model = {};
            this.relversoes = [];
            this.isNovo = true;
            this.pdfFile = null;

            if (this.relm_id) {
                this.isNovo = false;
                this.model = await relmodelosService.get(this.relm_id);
                // eslint-disable-next-line no-console
                //console.log(this.model);
                this.carregarRelversoes();
            }
        }
    }
}
</script>
